module.exports = __webpack_public_path__ + "img/ic_exam_detail.e78d6a5c.png";